import React from 'react';
import { useTranslation } from 'react-i18next';

const TIME_OPTIONS = [
    "12:00 am", "01:00 am", "02:00 am", "03:00 am", "04:00 am", "05:00 am",
    "06:00 am", "07:00 am", "08:00 am", "09:00 am", "10:00 am", "11:00 am",
    "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm",
    "06:00 pm", "07:00 pm", "08:00 pm", "09:00 pm", "10:00 pm", "11:00 pm"
];

const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
const getFirstDayOfMonth = (year, month) => {
    const day = new Date(year, month, 1).getDay();
    return day === 0 ? 6 : day - 1; // 0: lunes, ..., 6: domingo
};

// slice 02.1 · paso b.3 — presentacional. El popover "calendly" de fecha/hora de una tarea
// (era JSX duplicado en la fila de la lista y en el panel de detalle + los helpers
// `renderPopoverCalendarDays`/`getDaysInMonth`/`getFirstDayOfMonth`). `variant="panel"` añade
// la clase de override del panel. El contenedor mantiene `popoverDate`/`popoverDurationVal`/
// `popoverMonth`/`popoverYear` y hace el guardado en `on*Select`.
export const CalendlyDatePopover = ({ selectedTime, onTimeSelect, selectedDate, month, year, onPrevMonth, onNextMonth, onDateSelect, variant }) => {
    const { t: translate } = useTranslation('tasks');

    const dayCells = [];
    const firstDay = getFirstDayOfMonth(year, month);
    for (let i = 0; i < firstDay; i++) {
        dayCells.push(<div key={`empty-${i}`} className="popover-calendar-day empty" />);
    }
    const pad = (n) => String(n).padStart(2, '0');
    for (let day = 1; day <= getDaysInMonth(year, month); day++) {
        const dateStr = `${year}-${pad(month + 1)}-${pad(day)}`;
        dayCells.push(
            <div
                key={day}
                className={`popover-calendar-day ${selectedDate === dateStr ? 'selected' : ''}`}
                onClick={() => onDateSelect(dateStr)}
            >
                {day}
            </div>
        );
    }

    return (
        <div className={`calendly-glass-popover${variant === 'panel' ? ' task-panel-calendly-override' : ''}`} onClick={(e) => e.stopPropagation()}>
            <div className="calendly-popover-columns">
                <div className="calendly-left-col">
                    <div className="calendly-section-title">{translate('modal.startTime')}</div>
                    <div className="time-popover-time-list" style={{ overflowY: 'auto', maxHeight: '200px', display: 'flex', flexDirection: 'column', gap: '4px', paddingRight: 'var(--space-1)' }}>
                        {TIME_OPTIONS.map(timeStr => (
                            <button
                                key={timeStr}
                                type="button"
                                className={`time-preset-btn ${selectedTime === timeStr ? 'selected' : ''}`}
                                onClick={() => onTimeSelect(timeStr)}
                                style={{ textAlign: 'center', width: '100%', padding: 'var(--space-2)' }}
                            >
                                {timeStr}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="calendly-right-col">
                    <div className="calendly-month-nav">
                        <button type="button" className="month-nav-arrow" onClick={onPrevMonth} aria-label={translate('modal.monthPrev')}>&lt;</button>
                        <span className="month-nav-title">{translate('modal.monthNames', { returnObjects: true })[month]} {year}</span>
                        <button type="button" className="month-nav-arrow" onClick={onNextMonth} aria-label={translate('modal.monthNext')}>&gt;</button>
                    </div>

                    <div className="calendly-days-grid-header">
                        {translate('modal.weekDaysShort', { returnObjects: true }).map((d, i) => <span key={i}>{d}</span>)}
                    </div>

                    <div className="calendly-days-grid">
                        {dayCells}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalendlyDatePopover;
